import { render, staticRenderFns } from "./CreateCustomerCrmContactPopUp.vue?vue&type=template&id=54471a4b&scoped=true&"
import script from "./CreateCustomerCrmContactPopUp.vue?vue&type=script&lang=js&"
export * from "./CreateCustomerCrmContactPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateCustomerCrmContactPopUp.vue?vue&type=style&index=0&id=54471a4b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54471a4b",
  null
  
)

export default component.exports